import { Table } from "@pentabd/ui";
import { useTranslation } from "react-i18next";
import { CommitteeTableColumn } from "./CommitteeTableColumn";
import { SelectedMemberType } from "@type/procurements/committee";

type Props = {
  selectedMembers: SelectedMemberType[] | [];
  deleteCommitteeMember: (id: number) => void;
};

export default function CommitteeTable({
  selectedMembers,
  deleteCommitteeMember,
}: Props) {
  const { t } = useTranslation();
  return (
    <Table
      columns={CommitteeTableColumn(t, deleteCommitteeMember)}
      // remove={{
      //   customIcon: <IconTrash01 size={24} fill="danger" />,
      //   onClick: (id) => {
      //     deleteCommitteeMember(id as number);
      //   },
      // }}
      rows={selectedMembers || []}
    />
  );
}
